module.exports = __webpack_public_path__ + "static/fonts/DaimlerCS-Demi.5c861ad9.woff2";